/*
 * @Author: liuyongjun
 * @Date: 2023-02-07 10:11:35
 * @LastEditors: renshanshan
 * @LastEditTime: 2025-04-17 15:00:14
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/homePage.js
 */
const routerObj = {
  passengerList: '',
  standDistribution: '',
  flightCompensation: '',
  flightOperationDetails: '',
  flightLoad: '',
  passengerThroughput: '',
  AmapView: '',
  passengerInfo: '',
  unitInfo: '',
  trendAnalysis: '',
  unitDetail: '',
  airDetail: '',
  outerSafeguard: '',
  vipPage: '',
  businessInfo: '',
  beforeFlight: '',
  eventCheckList: '',
  beginAssign: '',
  previewFile: '',
  flightNormal: '',
  eventDetail: '',
  flightSituation: '',
  feedBack: '',
  normalAnalysis: ''
}
Object.keys(routerObj).forEach(key => {
  routerObj[key] = r => require.ensure([], () => r(require(`@/views/Home/${key}.vue`), key))
})
// 路由组件注册
const router = []
Object.keys(routerObj).forEach(key => {
  const obj = { path: `/${key}`, name: key, component: routerObj[key] }
  if (key === 'trendAnalysis') obj.meta = { title: '运输旅客趋势性分析' }
  router.push(obj)
})
export default router
